import { render, staticRenderFns } from "./TalkForwardRecord.vue?vue&type=template&id=3b71f88c&scoped=true"
import script from "./TalkForwardRecord.vue?vue&type=script&lang=js"
export * from "./TalkForwardRecord.vue?vue&type=script&lang=js"
import style0 from "./TalkForwardRecord.vue?vue&type=style&index=0&id=3b71f88c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b71f88c",
  null
  
)

export default component.exports